import {
  Alert,
  Autocomplete,
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  getUserEducations,
  deleteUserEducation,
  updateUserFile,
} from "../../../store/profile/actions";
import NoResults from "../../common/components/NoResults";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import AlertDialog from "../components/AlertDialog";
import EducationFormDialog from "./EducationFormDialog";
import PreviewPdfUrl from "../../common/components/PreviewPdfUrl";
import AdvertSkeleton from "../../common/components/AdvertSkeleton";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import LockIcon from "@mui/icons-material/Lock";
import moment from "moment";

export const Educations = (props) => {
  const {
    userProfile,
    env,
    loading,
    onWait,
    userEducations,
    getUserEducations,
    deleteUserEducation,
    updateUserFile,
    canEdit,
  } = props;

  useEffect(() => {
    getUserEducations(userProfile.id);
  }, []);

  // const [viewDocument, setViewDocument] = useState(null);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const [showEducationFormDialog, setShowEducationFormDialog] = useState(false);
  const [selectedEducation, setSelectedEducation] = useState(null);

  return (
    <>
      <Card className={`border rounded mb-3`} elevation={1} id="educations">
        <CardContent>
          {loading && !onWait && !userEducations.length ? (
            <AdvertSkeleton />
          ) : (
            <div className="container-fluid">
              <div className="d-flex flex-row justify-content-between align-items-center bg-light border px-3 py-1">
                <div>
                  <Typography
                    variant="h6"
                    style={{ color: "#078ece" }}
                    className="mr-1"
                  >
                    Education background
                  </Typography>
                </div>
                {canEdit && (
                  <Button
                    size="small"
                    variant="contained"
                    startIcon={<AddRoundedIcon />}
                    disabled={loading}
                    onClick={() => setShowEducationFormDialog(true)}
                  >
                    <span className="d-none d-md-inline mr-1">Add</span> new
                  </Button>
                )}
              </div>

              {userEducations.length === 0 ? (
                <NoResults />
              ) : (
                userEducations.map((education, index) => (
                  <EducationItemCard
                    key={education.id}
                    education={education}
                    index={index}
                    loading={loading}
                    deleteUserEducation={deleteUserEducation}
                    setSelectedEducation={setSelectedEducation}
                    setShowEducationFormDialog={setShowEducationFormDialog}
                    setLoadingDocument={setLoadingDocument}
                    updateUserFile={updateUserFile}
                    env={env}
                    canEdit={canEdit}
                  />
                ))
              )}
            </div>
          )}
        </CardContent>
      </Card>

      {showEducationFormDialog && (
        <EducationFormDialog
          onShow={showEducationFormDialog}
          selectedEducation={selectedEducation}
          onClose={() => {
            setShowEducationFormDialog(false);
            setSelectedEducation(null);
          }}
        />
      )}

      <div
        className={`page-loading-void position-fixed ${
          loadingDocument ? "d-block" : "d-none"
        }`}
      >
        {loadingDocument && (
          <CircularProgress
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              color: "rgb(7, 142, 206)",
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
            size={40}
            thickness={4}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  userProfile,
  env,
  loading,
  onWait,
  userEducations,
}) => ({
  userProfile,
  env,
  loading,
  onWait,
  userEducations,
});

const mapDispatchToProps = {
  getUserEducations,
  deleteUserEducation,
  updateUserFile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Educations);

const EducationItemCard = (props) => {
  const {
    loading,
    env,
    education,
    deleteUserEducation,
    setSelectedEducation,
    setShowEducationFormDialog,
    setLoadingDocument,
    updateUserFile,
    canEdit,
  } = props;

  const [onViewDocument, setOnViewDocument] = useState(false);
  const [onDelete, setOnDelete] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Card
        className={`mb-2 rounded hoverable-card `}
        elevation={0}
        variant="outlined"
        style={{
          backgroundColor: "#fff",
          border: "none",
        }}
      >
        <CardHeader
          avatar={
            <span className="font-weight-bold text-primary">
              {education?.graduationYear}
            </span>
          }
          title={<Typography>{education?.qualification?.name}</Typography>}
          subheader={
            <span>
              <span className="btn-link">{education?.school?.name}</span> /{" "}
              <strong>{education.school?.country?.name}</strong>
              {!!education.updatedOn && (
                <p
                  className="small text-muted mb-0 rounded-3 mt-2 float-end"
                  style={{
                    fontSize: "11px",
                  }}
                >
                  Updated on, {moment(education.updatedOn).format("ll")}
                </p>
              )}
              {!education.updatedOn && (
                <p
                  className="small text-muted mb-0 rounded-3 mt-2 float-end"
                  style={{
                    fontSize: "11px",
                  }}
                >
                  Created on, {moment(education.createdOn).format("ll")}
                </p>
              )}
            </span>
          }
          action={
            <>
              <div
                className="d-flex flex-row align-items-center "
                style={{ borderRadius: "4px" }}
              >
                <IconButton
                  // disableRipple
                  className=""
                  size="small"
                  onClick={() => {
                    if (education.docReferenceId) {
                      setOnViewDocument(true);
                    } else {
                      updateUserFile(
                        education,
                        "CHANGE_EDUCATION_FILE",
                        education.userId + "-" + education.qualification.name,
                        setOnViewDocument,
                        setLoadingDocument
                      );
                    }
                  }}
                >
                  <FilePresentIcon
                    // fontSize="large"
                    style={{
                      color: !!education.docReferenceId
                        ? "#fe4066"
                        : "#c57c7cb8",
                    }}
                  />
                </IconButton>
                {education.locked && (
                  <IconButton
                    disableRipple
                    size="small"
                    className=""
                    aria-label="settings"
                  >
                    <LockIcon />
                  </IconButton>
                )}
                {(!education.locked || env !== "prod") && canEdit && (
                  <>
                    <IconButton
                      size="small"
                      className=""
                      onClick={handleOpenMenu}
                      aria-label="settings"
                    >
                      <Badge color="info">
                        <span className="material-icons">more_vert</span>
                      </Badge>
                    </IconButton>
                    <Menu
                      anchorEl={anchorEl}
                      id="account-menu"
                      open={open}
                      onClose={handleCloseMenu}
                      PaperProps={{
                        elevation: 0,
                        sx: {
                          overflow: "visible",
                          filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                          mt: 1.5,
                          "& .MuiAvatar-root": {
                            width: 32,
                            height: 32,
                            ml: -0.5,
                            mr: 2,
                          },
                          "&:before": {
                            content: '""',
                            display: "block",
                            position: "absolute",
                            top: 0,
                            right: 15,
                            width: 10,
                            height: 10,
                            bgcolor: "background.paper",
                            transform: "translateY(-50%) rotate(45deg)",
                            zIndex: 0,
                          },
                        },
                      }}
                      transformOrigin={{ horizontal: "right", vertical: "top" }}
                      anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                    >
                      <span>
                        <MenuItem
                          disabled={loading}
                          onClick={() => {
                            handleCloseMenu();
                            setSelectedEducation(education);
                            setShowEducationFormDialog(true);
                          }}
                          className="text-dark font-weight-light"
                        >
                          <span className="material-icons mr-1">edit_note</span>
                          Edit
                        </MenuItem>
                      </span>

                      <span>
                        <MenuItem
                          disabled={loading}
                          onClick={() => {
                            handleCloseMenu();
                            setOnDelete(true);
                          }}
                          className="text-danger font-weight-light"
                        >
                          <span className="material-icons mr-1">remove</span>{" "}
                          Remove
                        </MenuItem>
                      </span>
                    </Menu>
                  </>
                )}
              </div>
            </>
          }
        />
      </Card>
      <Divider variant="fullWidth" />
      <Divider variant="fullWidth" />

      {onDelete && (
        <AlertDialog
          status={onDelete}
          handleClose={() => setOnDelete(false)}
          handleConfirm={() =>
            deleteUserEducation(education.id, () => setOnDelete(false))
          }
          title="Delete qualification"
          desc="Are your sure you want to delete this qualification?"
          disabled={loading}
        />
      )}

      {onViewDocument && (
        <PreviewPdfUrl
          showDocument={onViewDocument}
          setShowDocument={() => setOnViewDocument(false)}
          document={{
            name: `Education document`,
            url:
              process.env.REACT_APP_FILES_URL +
              "/preview/" +
              education.docReferenceId,
          }}
        />
      )}
    </>
  );
};
